module.exports = __webpack_public_path__ + "static/media/home.b18170ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home.png
// module id = 153
// module chunks = 0